import './local.css';

function EdcMz(){
    return (
        <div className='App'>
            <div className="container">
                <div className='header'>
                    <h1>EDC MZ</h1>
                </div>
                <div className="body">
                    <p>EDC MZ é uma plataforma digital de exames da escola de condução que impulsiona o aprendizado teórico para obtenção da carta de condução em Moçambique. Desenvolvida para facilitar o estudo e preparação dos candidatos, oferecendo uma experiência de aprendizado moderna e eficaz.</p> 
                    <p>A EDC MZ possuí as seguintes funcionalidades: </p>

                    <ul>
                        <li><strong>Exames Simulados:</strong> Simulações de exames teóricos com questões atualizadas conforme o código de estrada moçambicano, permitindo que os candidatos pratiquem em condições similares ao exame real.</li>
                        <li><strong>Biblioteca de Questões:</strong> Amplo banco de questões organizadas por categorias (sinais de trânsito, regras de circulação, primeiros socorros, etc.), facilitando o estudo focado em áreas específicas.</li>
                        <li><strong>Estatísticas de Desempenho:</strong> Acompanhamento detalhado do progresso do candidato com gráficos e relatórios de desempenho, identificando pontos fortes e áreas que precisam de mais atenção.</li>
                        <li><strong>Modo de Estudo Adaptativo:</strong> Sistema inteligente que adapta a dificuldade das questões com base no desempenho do utilizador, otimizando o tempo de estudo e garantindo melhor preparação.</li>
                        <li><strong>Acesso Móvel:</strong> Plataforma acessível via smartphone, tablet e computador, permitindo que os candidatos estudem a qualquer hora e em qualquer lugar.</li>
                        <li><strong>Conteúdo Atualizado:</strong> Material teórico constantemente atualizado de acordo com as últimas alterações do código de estrada e legislação de trânsito em Moçambique.</li>
                    </ul>

                    <p><strong>Benefícios da EDC MZ:</strong></p>
                    <ul>
                        <li>Aumento das taxas de aprovação nos exames teóricos</li>
                        <li>Estudo flexível e conveniente</li>
                        <li>Redução de custos com aulas repetidas</li>
                        <li>Preparação mais eficiente e direcionada</li>
                        <li>Confiança e segurança no dia do exame oficial</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}

export default EdcMz


